import React, { useState, useEffect } from 'react';
import CopySVG from '../../assets/svg/CopySVG';
import './CopyToClipboard.scss';

type ICopyToClipboardCustom = {
  text: string;
  className?: string;
  sliceNumber?: number;
  lastSliceNumber?: number;
  isSlice?: boolean;
  spanStyle?: string;
  onClick?: () => void;
  textStyle?: string;
}

const CopyToClipboard: React.FC<ICopyToClipboardCustom> = ({onClick,textStyle, isSlice= false, spanStyle, text, sliceNumber = 3, className = '', lastSliceNumber = 3  }) => {
  const [copy, setCopy] = useState<boolean>(false);

  useEffect(() => {
    const timeoutID = setTimeout(() => {
      if (copy) {
        setCopy(false);
      }
    }, 1000);

    return () => {
      clearTimeout(timeoutID);
    };
  }, [copy]);

  const handleOnClick = (e: any) => {
    navigator.clipboard.writeText(text);
    setCopy(true);
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <button className={`copy-button d-flex align-items-center ${className} ${copy ? "flashBG" : ""}`}>
      {
        isSlice ?
          <span className={textStyle}>{text?.slice(0, sliceNumber) + "..." + text?.slice(text.length - lastSliceNumber)}</span>
          : ( onClick ? <div onClick={onClick} className={spanStyle}>{text}</div> : <span className={spanStyle}>{text}</span>)
      }
      <div className="position-relative" onClick={(e:any) => handleOnClick(e)}>
        <CopySVG />
        <span className={`copied ${copy ? "animation" : ""}`}>copied!</span>
      </div>
    </button>
  );
};

export default CopyToClipboard;
